<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne :readOnly="readOnly" :horasExtraordinarias="horasExtraordinarias" />
  </div>
</template>

<script>
import TableOne from "./components/mainTableSix/TableOne";

export default {
  props: ["horasExtraordinarias", "readOnly"],
  components: {
    TableOne,
  },
  data() {
    return {
      //Primary Table
      titleOne:
        "6 Promedio mensual de horas extraordinarias realizadas por funcionarios",
      encabezado: "Variables",
      textOne: "(a) N° de horas extraordinarias año t, / 12",
      textTwo: "(b) Total Dotación Efectiva año t",
      textThree: "Promedio mensual horas extraordinarias por funcionario (a/b)",
      inputFour: "",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
      inputFive: "",
      inputSix: "",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
